<template>
  <v-container
    fluid
    fill-height
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        v-if="showMenuWebReport"
        cols="6"
        sm="5"
        md="3"
        lg="2"
      >
        <div
          class="text-center text-h6 font-weight-bold pb-3 menu-comparison-text"
        >
          他店舗比較
        </div>
        <v-card
          class="top-menu-card web-report"
          :to="{name: 'comparison.summary'}"
          link
          :disabled="disabledWebReport"
        >
          <v-responsive :aspect-ratio="1/1">
            <v-row
              align="center"
              justify="center"
              no-gutters
              class="fill-height"
            >
              <v-col
                class="text-center"
              >
                <img
                  contain
                  class="d-block top-menu-img"
                  width="100%"
                  :src="require('/src/assets/images/menu_comparison.svg')"
                />
              </v-col>
            </v-row>
          </v-responsive>
        </v-card>
      </v-col>
      <v-col
        v-if="showMenuDemandReport"
        cols="6"
        :offset-sm="showMenuWebReport ? 1 : 0"
        sm="5"
        :offset-md="showMenuWebReport ? 1 : 0"
        md="3"
        :offset-lg="showMenuWebReport ? 1 : 0"
        lg="2"
      >
        <div
          class="text-center text-h6 font-weight-bold pb-3 menu-demand-text"
        >
          需要予測
        </div>
        <v-card
          class="top-menu-card demand-report"
          :to="{name: 'demand.visitor'}"
          link
          :disabled="disabledDemandReport"
        >
          <v-responsive :aspect-ratio="1/1">
            <v-row
              align="center"
              justify="center"
              no-gutters
              class="fill-height"
            >
              <v-col
                class="text-center"
              >
                <img
                  contain
                  class="d-block top-menu-img"
                  width="100%"
                  :src="require('/src/assets/images/menu_demand.svg')"
                />
              </v-col>
            </v-row>
          </v-responsive>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {AGREEMENT_STATUS_AGREEMENT} from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'TopMenu',
  computed: {
    ...mapGetters ({
      agreement_web_report: 'auth/agreement_web_report',
      agreement_demand_report: 'auth/agreement_demand_report',
    }),
    disabledWebReport: function () {
      return this.agreement_web_report === AGREEMENT_STATUS_AGREEMENT ? false : true
    },
    disabledDemandReport: function () {
      return this.agreement_demand_report === AGREEMENT_STATUS_AGREEMENT ? false : true
    },
    showMenuWebReport: function () {
      return process.env.VUE_APP_SHOW_MENU_WEB === undefined ? true : String(process.env.VUE_APP_SHOW_MENU_WEB).toLowerCase() === 'true'
    },
    showMenuDemandReport: function () {
      return process.env.VUE_APP_SHOW_MENU_DEMAND === undefined ? true : String(process.env.VUE_APP_SHOW_MENU_DEMAND).toLowerCase() === 'true'
    }
  },
}
</script>
<style lang="scss" scoped>
  .top-menu-card {
    &.v-card--disabled {
      background: {
        color: #c2c2c2!important;
      }
      &>*:not(.v-card__progress) {
        opacity: 1!important;
      }
      .top-menu-img {
        filter: grayscale(1);
      }
    }
  }
  .menu-demand-text,
  .menu-comparison-text {
    color: #1D3156;
  }
</style>